import initialState from '../store/initial-state'
import {
  PLAN_SERVICES_GET_DATA,
  PLAN_SERVICES_GET_DATA_FAILURE,
  PLAN_SERVICES_GET_DATA_SUCCESS, 
  PLAN_SERVICES_SEND, 
  PLAN_SERVICES_SEND_FAILURE, 
  PLAN_SERVICES_SEND_SUCCESS,
  PLAN_SERVICES_BY_USER,
  PLAN_SERVICES_BY_USER_SUCCESS,
  PLAN_SERVICES_BY_USER_FAILURE,
  PLAN_SERVICES_BY_USER_UPDATE,
  PLAN_SERVICES_BY_USER_SUCCESS_UPDATE,
  PLAN_SERVICES_BY_USER_FAILURE_UPDATE,
  UPDATE_PLAN_LINK_GENERATE,
  UPDATE_PLAN_LINK_GENERATE_SUCCESS,
  UPDATE_PLAN_LINK_GENERATE_ERROR,
  REDUCE_PLAN,
  REDUCE_PLAN_SUCCESS,
  REDUCE_PLAN_ERROR,
} from "../constants/plan-services-types";

export default (state = initialState.planServices, action) => {
  switch (action.type) {
    case PLAN_SERVICES_GET_DATA:
      return {
        ...state,
        isFetching: action.payload.isFetching,
        data: action.payload.data.map(e => ({...e, idService: e._id})),
        headers: null,
        error: null
      }

    case PLAN_SERVICES_GET_DATA_SUCCESS:
      return {
        ...state,
        isFetching: false,
        data: action.payload.data.map(e => ({...e, idService: e._id})),
        headers: action.payload.headers,
        error: null
      }

    case PLAN_SERVICES_GET_DATA_FAILURE:
      return {
        ...state,
        isFetching: false,
        data: [],
        headers: null,
        error: action.payload
      }

    case PLAN_SERVICES_SEND:
      return {
        ...state,
        isFetching: true,
      }

    case PLAN_SERVICES_SEND_SUCCESS:
      return {
        ...state,
        isFetching: false,
        headers: action.payload.headers,
        error: null
      }

    case PLAN_SERVICES_SEND_FAILURE:
      return {
        ...state,
        isFetching: false,
        headers: null,
        error: action.payload
      }
    case PLAN_SERVICES_BY_USER:
      return {
        ...state,
        fetchingUserServices: true,
      }

    case PLAN_SERVICES_BY_USER_SUCCESS:
      return {
        ...state,
        fetchingUserServices: false,
        userServices: action.payload.modules,
        error: null
      }

    case PLAN_SERVICES_BY_USER_FAILURE:
      return {
        ...state,
        fetchingUserServices: false,
        userServices: null,
        errorUserServices: action.payload
      }
    case PLAN_SERVICES_BY_USER_UPDATE:
      return {
        ...state,
        fetchingUserServices: true,
      }

    case PLAN_SERVICES_BY_USER_SUCCESS_UPDATE:
      return {
        ...state,
        fetchingUserServices: false,
        userServices: action.payload.modules,
        error: null
      }

    case PLAN_SERVICES_BY_USER_FAILURE_UPDATE:
      return {
        ...state,
        fetchingUserServices: false,
        errorUserServices: action.payload
      }
    case UPDATE_PLAN_LINK_GENERATE:
      return {
        ...state,
        linkGenerateLoading: true,
        linkGenerateError: false,
        linkGenerate: null
      }
    case UPDATE_PLAN_LINK_GENERATE_SUCCESS:
      return {
        ...state,
        linkGenerateLoading: false,
        linkGenerateError: false,
        linkGenerate: action.payload.link
      }
    case UPDATE_PLAN_LINK_GENERATE_ERROR:
      return {
        ...state,
        linkGenerateLoading: false,
        linkGenerateError: true,
        linkGenerate: null
      }
    case REDUCE_PLAN:
      return {
        ...state,
        reducePlanLoading: true,
        reducePlanError: false,
      }
    case REDUCE_PLAN_SUCCESS:
      return {
        ...state,
        reducePlanLoading: false,
        reducePlanError: false,
      }
    case REDUCE_PLAN_ERROR:
      return {
        ...state,
        reducePlanLoading: false,
        reducePlanError: true,
      }

    default: return { ...state }
  }
}
